'use strict';
const assert = require('assert');
const Orders = require('../orders');
const chai = require('chai');
const sdkConfiguration = require('../../configurations/sdk-configuration');

const expect = chai.expect;
const credentials = {
  domain: 'csDesarrollo.onmicrosoft.com',
  clientId: 'f7d796b6-c2fe-4e70-b17f-e5d919695487',
  userName: 'app@csDesarrollo.onmicrosoft.com',
  password: 'Inn0vaci0n',
};
const fakeCustomerId = '123456789';
const fakeRequest = options => Promise.resolve(options);

/* eslint-disable no-undef, no-unused-vars */
describe('Orders', () => {
  it('Creates a correct instance of the class', (done) => {
    const orders = new Orders(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    expect(orders).to.have.property('requestManager');
    expect(orders.requestManager).to.have.property('requestConfigurationManager');
    expect(orders.requestManager).to.have.property('authConfiguration');
    expect(orders.requestManager.requestConfigurationManager).to.have.property('sdkConfiguration');
    expect(orders.requestManager.requestConfigurationManager).to.have.property('credentials');
    expect(orders.requestManager.requestConfigurationManager).to.have.property('request');
    expect(orders).to.have.property('paramsManager');
    expect(orders.paramsManager).to.have.property('pathParams');
    expect(orders.paramsManager).to.have.property('bodyParams');
    expect(orders.paramsManager).to.have.property('queryParams');
    assert(orders.paramsManager.pathParams[0] === '123456789');
    done();
  });
  it('get, if orderId is set it must return the order details', (done) => {
    const orders = new Orders(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    orders.byId('66').get().then((orderDetails) => {
      assert(orderDetails.method === 'GET');
      assert(orderDetails.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/orders/66');
      assert(orderDetails.headers.Accept === 'application/json');
      assert(orderDetails.headers['Content-Type'] === 'application/json');
      expect(orderDetails.headers).to.have.property('MS-RequestId');
      expect(orderDetails.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('get, if orderId is not set, return all the customer´s orders', (done) => {
    const orders = new Orders(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    orders.get().then((allOrders) => {
      assert(allOrders.method === 'GET');
      assert(allOrders.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/orders');
      assert(allOrders.headers.Accept === 'application/json');
      assert(allOrders.headers['Content-Type'] === 'application/json');
      expect(allOrders.headers).to.have.property('MS-RequestId');
      expect(allOrders.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
  it('create, the order params must be added to the body', (done) => {
    const orders = new Orders(credentials, fakeRequest, sdkConfiguration, fakeCustomerId);
    orders.create({ sku: 'aabbcc' }).then((orderCreate) => {
      assert(orderCreate.method === 'POST');
      assert(orderCreate.uri === 'https://api.partnercenter.microsoft.com/v1/customers/123456789/orders');
      assert(orderCreate.body.sku === 'aabbcc');
      assert(orderCreate.headers.Accept === 'application/json');
      assert(orderCreate.headers['Content-Type'] === 'application/json');
      expect(orderCreate.headers).to.have.property('MS-RequestId');
      expect(orderCreate.headers).to.have.property('MS-CorrelationId');
    })
      .then(done, done);
  });
});
